
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ECommExchangeGrid extends Serenity.EntityGrid<ECommExchangeRow, any> {
        protected getColumnsKey() { return 'ECommerce.ECommExchange'; }
        protected getDialogType() { return ECommExchangeDialog; }
        protected getIdProperty() { return ECommExchangeRow.idProperty; }
        protected getInsertPermission() { return ECommExchangeRow.insertPermission; }
        protected getLocalTextPrefix() { return ECommExchangeRow.localTextPrefix; }
        protected getService() { return ECommExchangeService.baseUrl; } 
        private autoSize;
        constructor(container: JQuery) {
            super(container); 
        }

        protected addButtonClick() {
            
            let now = new Date();
            var userDefinition = Q.Authorization.userDefinition;
            var autoposting = OMS.VoucherMasterRow.getLookup().itemById[89].AutoPosting;
            var voucherNo = FormatHelper.GetVoucherNo(89);
            this.editItem(<ECommExchangeRow>{
                VoucherNo: voucherNo,
                Line_No: 0,
                CompanyId: userDefinition.CompanyId,
                FinancialYearId: userDefinition.FinancialYearId,
                UserId: userDefinition.UserId,
                CurrencyId: userDefinition.CurrencyId,
                VoucherTypeId: 89,
                TransDate: now.toDateString(),
                AutoPosting: autoposting
                       
            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        } 

        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}